import { FilterOption, SearchFieldAttr, SearchGroup } from "@core/interfaces";

import CheckBox from "./CheckBox";
import Radio from "./Radio";
import Selector from "./Selector";
import Text from "./Text";

interface Props {
  title: string;
  fields: SearchFieldAttr[];
  onSearch: (values: any, type: string) => void;
  extra?: JSX.Element;
  footer?: {
    component: JSX.Element;
    span: number;
  };
  column?: number;
}

const Search = ({ fields, onSearch }: Props) => {
  const renderFilterType = (
    filter: SearchGroup,
    onFinish: (values: any, type: string) => void
  ) => {
    let data = filter.data;
    const { type, name, convertHTML, placeholder } = filter;

    if (type === "radio" || type === "selector" || type === "selector-role" || type === "checkbox" || type === "selector-view-rank") {
      if (!data) {
        data = [];
      }
    }

    switch (filter.type) {
      case "text":
        return (
          <Text
            className={filter.className}
            name={name}
            placeholder={placeholder}
            onFinish={onFinish}
          />
        );
      case "radio":
        return (
          <Radio
            className={filter.className}
            name={name}
            data={data as FilterOption[]}
            convertHTML={convertHTML}
          />
        );
      case "selector":
        return (
          <Selector
            type={type}
            placeholder={placeholder}
            className={filter.className}
            name={name}
            data={data as FilterOption[]}
            onFinish={onFinish}
          />
        );
      case "selector-role":
        return (
          <Selector
            type={type}
            placeholder={placeholder}
            className={filter.className}
            name={name}
            data={data as FilterOption[]}
            onFinish={onFinish}
          />
        );
      case "selector-view-rank":
        return (
          <Selector
            type={type}
            placeholder={placeholder}
            className={filter.className}
            name={name}
            data={data as FilterOption[]}
            onFinish={onFinish}
          />
        );
      case "checkbox":
        return (
          <CheckBox
            className={filter.className}
            name={name}
            data={data as FilterOption[]}
          />
        );
      default:
        return null;
    }
  };

  const onFinish = (values: any, type: string) => {
    // const filter = fields.reduce((prev: Record<string, any>, field) => {
    //   if (field.removeWhenValueIsAll && values[field.name] === "all") {
    //     return prev;
    //   }

    //   if (values[field.name]) {
    //     let value = values[field.name];

    //     if (field.opt === "$like") {
    //       value = `%${value}%`;
    //     }

    //     prev[field.name] = { [field.opt]: value };
    //   }

    //   return prev;
    // }, {});
    if (type === "text") onSearch(values.target.value, type);
    if (type === "selector") onSearch(values, type);
    if (type === "selector-role") onSearch(values, type);
    if (type === "selector-view-rank") onSearch(values, type);
  };

  return (
    <div className="core-search">
      {fields.map((field) => {
        return (
          <div className={`search-${field.type}`}>
            {renderFilterType(field, onFinish)}
          </div>
        );
      })}
    </div>
  );
};

export default Search;
